<template>
  <section>
    <Navbar />

    <div>
      <div class="m-b-30">
        <div class="container">
          <div class="row p-b-60 p-t-60"></div>
        </div>
      </div>
    </div>

    <section>
      <div class="container">
        <div class="row list">
          <div class="col-md-12" v-show="show">
            <div class="card m-b-30">
              <div class="card-body">
                <div class="row">
                  <div class="form-group col-md-12">
                    <label>Select Facility</label>
                    <select class="form-control" v-model="selected_provider">
                      <option
                        v-for="provider in providers"
                        v-bind:key="provider.id"
                        :value="provider"
                      >
                        {{ provider.agency_name }}
                      </option>
                    </select>
                  </div>
                </div>

                <button
                  @click="filterProvider()"
                  class="btn btn-primary btn-block btn-lg"
                  style="margin-top: 20px"
                >
                  Filter
                </button>
                <br />

                <div v-show="showdownload">
                  <div v-if="loader == true">
                    <vue-loaders
                      name="line-spin-fade-loader"
                      color="black"
                      scale="1"
                    ></vue-loaders>
                    Preparing data for download for Health Facility
                  </div>
                  <div v-else>
                    <download-excel
                      :data="json_data"
                      :fields="json_fields"
                      class="btn btn-success"
                      :header="
                        'Enrollee Data for' + selected_provider.agency_name
                      "
                      :escapeCsv="false"
                      :name="selected_provider.agency_name + '.xls'"
                    >
                      <span class="fe fe-download"></span>
                      Download {{ json_data.length }} Data for
                      {{ selected_provider.agency_name }}
                    </download-excel>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div class="vld-parent">
          <loading
            :active.sync="isLoading"
            loader="dots"
            :can-cancel="true"
            :is-full-page="fullPage"
          ></loading>
        </div>
      </div>
    </section>
  </section>
</template>

<script>
// Import component
import Loading from "vue-loading-overlay";
// Import stylesheet
import "vue-loading-overlay/dist/vue-loading.css";
// Init plugin
import Navbar from "@/views/Navbar.vue";

export default {
  components: {
    Loading,
    Navbar,
  },
  data() {
    return {
      loader: true,
      showdownload: false,
      user: null,
      providers: "",
      selected_provider: "",
      place_of_work: "",
      edit: false,
      show: true,
      isLoading: false,
      fullPage: false,
      agency_id: "",
      provider_id: "",
      mdas: [],
      state: "",
      lga_states: "",
      sector: "",
      wards: [],
      json_fields: {
        "MDA Name": "place_of_work",
        "First Name": "firstname",
        "Last Name": "lastname",
        "Middle Name": "middlename",
        "Health Facility": "userprovider.agency_name",
        "NIMC Number": "nimc_number",
        "KGSHIA Number": "id_card_number",
        "Date of Birth": "dob",
        Sector: "sector",
        "Expiry Date": "date_of_expiry",
        "Marital Status": "marital_status",
        Gender: "gender",
        phone_number: "phone_number",
      },
      json_data: [],
      json_meta: [
        [
          {
            key: "charset",
            value: "utf-8",
          },
        ],
      ],
    };
  },
  beforeMount() {
    this.user = JSON.parse(localStorage.getItem("user"));
    this.axios
      .get(`/api/v1/auth/providerAgency/90`)
      .then((response) => {
        this.providers = response.data.data;
        console.log(response);
      })
      .catch((error) => {
        console.error(error);
      });
  },
  methods: {
    filterProvider() {
      this.loader = true;
      this.axios
        .get(`/api/v1/auth/getProviderToUser/` + this.selected_provider.id)
        .then((response) => {
          this.json_data = response.data;
          console.log(response);
          this.loader = false;
          this.showdownload = true;
        })
        .catch((error) => {
          console.error(error);
        });
    },

    getMDAs() {
      this.axios
        .get(`/api/v1/auth/ministry`)
        .then((response) => {
          this.mdas = response.data;
          // console.log(response)
        })
        .catch(() => {
          // console.error(error);
        });
    },

    getProviders() {
      this.user = JSON.parse(localStorage.getItem("user"));

      this.axios
        .get(`/api/v1/auth/providerAgency/90`)
        .then((response) => {
          this.providers = response.data.data;
          // console.log(response.data.data)
        })
        .catch(() => {
          // console.error(error);
        });
    },

    clearIt() {
      this.agency_id = "";
    },
  },
  created() {
    // this.getProviders()
    this.getMDAs();
  },
};
</script>
